import { action } from '@/utils/actions.utils'

export const START_DOWNLOAD = 'START_DOWNLOAD'
const startDownload = (payload) => {
	return action(START_DOWNLOAD, payload)
}

export const UPDATE_DOWNLOAD = 'UPDATE_DOWNLOAD'
const updateDownload = (payload) => {
	return action(UPDATE_DOWNLOAD, payload)
}

export const DOWNLOAD_PROGRESS = 'DOWNLOAD_PROGRESS'
const downloadProgress = (payload) => {
	return action(DOWNLOAD_PROGRESS, payload)
}

export const DOWNLOAD_COMPLETE = 'DOWNLOAD_COMPLETE'
const downloadComplete = () => {
	return action(DOWNLOAD_COMPLETE)
}

export const UNDO_DOWNLOAD = 'UNDO_DOWNLOAD'
const undoDownload = () => {
	return action(UNDO_DOWNLOAD)
}

export const FILE_DOWNLOAD_METRICS = 'FILE_DOWNLOAD_METRICS'
const fileDownloadMetrics = (payload) => {
	return action(FILE_DOWNLOAD_METRICS, payload)
}

export default {
	startDownload,
	updateDownload,
	downloadProgress,
	downloadComplete,
	undoDownload,
	fileDownloadMetrics,
}
